import React, { useState } from 'react';
import { X } from 'lucide-react';

interface SettingsModalProps {
  isOpen: boolean;
  onClose: () => void;
  onSubmit: (data: { protocolFeeRate: string }) => void;
  isLoading?: boolean;
}

const SettingsModal: React.FC<SettingsModalProps> = ({
  isOpen,
  onClose,
  onSubmit,
  isLoading = false
}) => {
  const [formData, setFormData] = useState({
    protocolFeeRate: '',
  });

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    onSubmit(formData);
  };

  const handleClose = () => {
    setFormData({ protocolFeeRate: '' });
    onClose();
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-70 backdrop-blur-sm flex items-center justify-center overflow-y-auto h-full w-full z-50">
      <div className="relative top-20 mx-auto p-5 w-96 shadow-lg rounded-md bg-[#182233]">
        <div className="flex justify-between items-center mb-4">
          <h3 className="text-lg font-medium text-white">Platform Settings</h3>
          <button 
            onClick={handleClose} 
            className="text-gray-400 hover:text-gray-300"
            disabled={isLoading}
          >
            <X className="h-5 w-5" />
          </button>
        </div>
        
        <form onSubmit={handleSubmit} className="space-y-4">
          <div>
            <label className="block text-sm font-medium text-gray-400 mb-2">Protocol Fee Rate (Basis Points)</label>
            <input
              type="number"
              value={formData.protocolFeeRate}
              onChange={(e) => setFormData({ ...formData, protocolFeeRate: e.target.value })}
              className="w-full appearance-none rounded-md border-0 bg-[#567095]/20 px-3 py-2 placeholder-gray-400 text-white focus:outline-none focus:ring-2 focus:ring-[#2777EF] sm:text-sm"
              placeholder="Enter protocol fee rate"
              min="0"
              max="1000"
              required
              disabled={isLoading}
            />
            <p className="text-xs text-gray-400 mt-1">100 basis points = 1%</p>
          </div>
          
          <div className="flex justify-end space-x-3">
            <button
              type="button"
              onClick={handleClose}
              className="px-4 py-2 border border-[#567095]/30 text-sm font-medium rounded-md text-white bg-[#182233] hover:bg-[#567095]/20"
              disabled={isLoading}
            >
              Cancel
            </button>
            <button
              type="submit"
              className="px-4 py-2 border border-transparent text-sm font-medium rounded-md text-white bg-[#2777EF] hover:bg-[#0053E2] disabled:opacity-50"
              disabled={isLoading}
            >
              {isLoading ? 'Updating...' : 'Update Settings'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default SettingsModal;
